import { GasType } from "../../pages/project/results/hooks/resultTypes";

export const getGasColor = (gas: GasType) => {
	if (gas.name === "CO2") return "#433F3A";
	if (gas.name === "CH4") return "#C2CCB7"; 
	if (gas.name === "OTHER") return "#70A9A1";
	return "#315EB7";
};
